<h2>Información de Pasajeros</h2>

<div class="mat-elevation-z8 overflow" style="margin-top: 2rem">
  <div *ngIf="isLoading" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <table mat-table [dataSource]="dataSource" *ngIf="!isLoading">
    <ng-container matColumnDef="num">
      <th mat-header-cell *matHeaderCellDef>No.</th>
      <td mat-cell *matCellDef="let pax">{{ pax.Pax }}</td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.firstName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="apellido">
      <th mat-header-cell *matHeaderCellDef>Apellido</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="fechaNacimiento">
      <th mat-header-cell *matHeaderCellDef>Fecha de Nacimiento</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.dateOfBirth | date : "dd/MM/yyyy" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="genero">
      <th mat-header-cell *matHeaderCellDef>Género</th>
      <td mat-cell *matCellDef="let pax">{{ pax.gender }}</td>
    </ng-container>

    <ng-container matColumnDef="edad">
      <th mat-header-cell *matHeaderCellDef>Edad</th>
      <td mat-cell *matCellDef="let pax">{{ pax.age }}</td>
    </ng-container>

    <ng-container matColumnDef="talla">
      <th mat-header-cell *matHeaderCellDef>Talla</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.height }}
      </td>
    </ng-container>

    <ng-container matColumnDef="peso">
      <th mat-header-cell *matHeaderCellDef>Peso</th>
      <td mat-cell *matCellDef="let pax">{{ pax.weight }}</td>
    </ng-container>

    <ng-container matColumnDef="altura">
      <th mat-header-cell *matHeaderCellDef>Altura</th>
      <td mat-cell *matCellDef="let pax">{{ pax.height }}</td>
    </ng-container>

    <ng-container matColumnDef="grupo">
      <th mat-header-cell *matHeaderCellDef>Grupo</th>
      <td mat-cell *matCellDef="let pax">{{ pax.grupo }}</td>
    </ng-container>

    <ng-container matColumnDef="correo">
      <th mat-header-cell *matHeaderCellDef>Correo</th>
      <td mat-cell *matCellDef="let pax">{{ pax.email }}</td>
    </ng-container>

    <ng-container matColumnDef="pais">
      <th mat-header-cell *matHeaderCellDef>País</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.country }}
      </td>
    </ng-container>

    <ng-container matColumnDef="restricciones">
      <th mat-header-cell *matHeaderCellDef>Restricciones Alimenticias</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.restriccionesAlimentarias }}
      </td>
    </ng-container>

    <ng-container matColumnDef="alergias">
      <th mat-header-cell *matHeaderCellDef>Alergias</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.alergias }}
      </td>
    </ng-container>

    <ng-container matColumnDef="condiciones">
      <th mat-header-cell *matHeaderCellDef>Condiciones Médicas</th>
      <td mat-cell *matCellDef="let pax">
        {{ pax.condicionesMedicas }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
